import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from "./pages/AuthContext";
import PrivateRoute from "./pages/PrivateRoute";
import Login from "./pages/Login";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardPOS from "./pages/Dashboard_POS";
import DashboardPO from "./pages/Dashboard_PO";
import DashboardFabrics from "./pages/Dashboard_Fabrics";
import DashboardMechanics from "./pages/Dashboard_Mechanics";
import DashboardSuperAdmin from "./pages/Dashboard_SuperAdmin";
import SellList from "./pages/Fab_SaleList";
import DashboardMechanicsTH from "./pages/Dashboard_MechanicsTH";
import DashboardMechanicsAP from "./pages/Dashboard_MechanicsAP";
import DashboardHardwareAP from "./pages/Dashboard_HardwareAP";
import DashboardHardwareTH from "./pages/Dashboard_HardwareTH";
import DashboardAutosAP from "./pages/Dashboard_AutosAP";
import DashboardAutosTH from "./pages/Dashboard_AutosTH";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Login Route */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          
          {/* Super Admin Dashboard - exact path without /* to avoid conflicts */}
          <Route
            path="/DashboardSuperAdmin"
            element={
              <PrivateRoute requiredRole="super_admin">
                <DashboardSuperAdmin />
              </PrivateRoute>
            }
          />

          <Route
            path="/DashboardSuperAdmin/*"
            element={
              <PrivateRoute requiredRole="super_admin">
                <DashboardSuperAdmin />
              </PrivateRoute>
            }
          />

          {/* POS Dashboard */}
          <Route
            path="/DashboardPOS"
            element={
              <PrivateRoute allowedRoles={['admin_pos', 'manager_pos', 'user_pos', 'viewer_pos']}>
                <DashboardPOS />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardPOS/*"
            element={
              <PrivateRoute allowedRoles={['admin_pos', 'manager_pos', 'user_pos', 'viewer_pos']}>
                <DashboardPOS />
              </PrivateRoute>
            }
          />

          {/* PO Dashboard */}
          <Route
            path="/DashboardPO"
            element={
              <PrivateRoute allowedRoles={['admin_po', 'manager_po', 'user_po', 'viewer_po']}>
                <DashboardPO />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardPO/*"
            element={
              <PrivateRoute allowedRoles={['admin_po', 'manager_po', 'user_po', 'viewer_po']}>
                <DashboardPO />
              </PrivateRoute>
            }
          />

          {/* Fabrics Dashboard */}
          <Route
            path="/DashboardFabrics"
            element={
              <PrivateRoute allowedRoles={['admin_fabrics', 'manager_fabrics', 'user_fabrics', 'viewer_fabrics']}>
                <DashboardFabrics />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardFabrics/*"
            element={
              <PrivateRoute allowedRoles={['admin_fabrics', 'manager_fabrics', 'user_fabrics', 'viewer_fabrics']}>
                <DashboardFabrics />
              </PrivateRoute>
            }
          />

          {/* Mechanics Dashboard THERMAL*/}
          <Route
            path="/DashboardMechanicsTh"
            element={
              <PrivateRoute allowedRoles={['admin_mechanicsth', 'manager_mechanicsth', 'user_mechanicsth', 'viewer_mechanicsth']}>
                <DashboardMechanicsTH />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardMechanicsTh/*"
            element={
              <PrivateRoute allowedRoles={['admin_mechanicsth', 'manager_mechanicsth', 'user_mechanicsth', 'viewer_mechanicsth']}>
                <DashboardMechanicsTH />
              </PrivateRoute>
            }
          />

            {/* Mechanics Dashboard LARGE PRINTER*/}
          <Route
            path="/DashboardMechanicsAp"
            element={
              <PrivateRoute allowedRoles={['admin_mechanicsap', 'manager_mechanicsap', 'user_mechanicsap', 'viewer_mechanicsap']}>
                <DashboardMechanicsAP />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardMechanicsAp/*"
            element={
              <PrivateRoute allowedRoles={['admin_mechanicsap', 'manager_mechanicsap', 'user_mechanicsap', 'viewer_mechanicsap']}>
                <DashboardMechanicsAP />
              </PrivateRoute>
            }
          />

          {/* Hardware Dashboard LARGE PRINTER*/}
          <Route
            path="/DashboardHardwareAp"
            element={
              <PrivateRoute allowedRoles={['admin_hardwareap', 'manager_hardwareap', 'user_hardwareap', 'viewer_hardwareap']}>
                <DashboardHardwareAP />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardHardwareAp/*"
            element={
              <PrivateRoute allowedRoles={['admin_hardwareap', 'manager_hardwareap', 'user_hardwareap', 'viewer_hardwareap']}>
                <DashboardHardwareAP />
              </PrivateRoute>
            }
          />

          {/* Hardware Dashboard THERMAL*/}
          <Route
            path="/DashboardHardwareTh"
            element={
              <PrivateRoute allowedRoles={['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'viewer_hardwareth']}>
                <DashboardHardwareTH />
              </PrivateRoute>
            }

          />
          <Route
            path="/DashboardHardwareTh/*"
            element={
              <PrivateRoute allowedRoles={['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'viewer_hardwareth']}>
                <DashboardHardwareTH />
              </PrivateRoute>
            }
          />



          {/* Autos Dashboard LARGE PRINTER*/}
          <Route
            path="/DashboardAutosAp"
            element={
              <PrivateRoute allowedRoles={['admin_autosap', 'manager_autosap', 'user_autosap', 'viewer_autosap']}>
                <DashboardAutosAP />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardAutosAp/*"
            element={
              <PrivateRoute allowedRoles={['admin_autosap', 'manager_autosap', 'user_autosap', 'viewer_autosap']}>
                <DashboardAutosAP />
              </PrivateRoute>
            }
          />

          {/* Autos Dashboard THERMAL*/}
          <Route
            path="/DashboardAutosTh"
            element={
              <PrivateRoute allowedRoles={['admin_autosth', 'manager_autosth', 'user_autosth', 'viewer_autosth']}>
                <DashboardAutosTH />
              </PrivateRoute>
            }

          />
          <Route
            path="/DashboardAutosTh/*"
            element={
              <PrivateRoute allowedRoles={['admin_autosth', 'manager_autosth', 'user_autosth', 'viewer_autosth']}>
                <DashboardAutosTH />
              </PrivateRoute>
            }
          />

        

          {/* Legacy Dashboard route - fallback */}
          <Route
            path="/Dashboard/*"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          />

          {/* ----- FABRICS REDIRECTIONS --------------------------------------------------------------------- */}
          {/* Legacy Dashboard route - fallback */}
          <Route
            path="/dashboard/fab-sales"
            element={
              <PrivateRoute>
                <SellList />
              </PrivateRoute>
            }
          />

          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;